import React from "react";
import DataGrid, {
  Column,
  FilterRow,
  Paging,
  Pager,
  HeaderFilter,
} from "devextreme-react/data-grid";

import { useScreenSize } from "../../../utils/media-query";
import { formatMessage } from "devextreme/localization";

export default function PayslipTableList({
  dataSource,
  renderActions,
  dataGrid,
  // middleware,
}) {
  const { isXSmall, isSmall } = useScreenSize();
  return (
    <DataGrid
      id="gridContainer"
      height={document.documentElement.offsetHeight - 189}
      dataSource={dataSource}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      rowAlternationEnabled={true}
      columnResizingMode="widget"
      allowColumnResizing={true}
      columnAutoWidth={true}
      ref={dataGrid}
      alignment="center"
    >
      <HeaderFilter visible="true" />
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />

      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />

      <Column
        caption={formatMessage("EmployeeCode")}
        dataField="EmployeeCode"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      <Column
        caption={formatMessage("FullName")}
        dataField="FullName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      {/* <Column
        caption="Department Code"
        dataField="DepartmentCode"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      /> */}
      <Column
        caption={formatMessage("DepartmentName")}
        dataField="DepartmentName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      <Column
        caption={formatMessage("PositionName")}
        dataField="PositionName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />
      <Column
        caption={formatMessage("PeriodName")}
        dataField="PeriodName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 4 : false}
      />

      <Column
        caption={formatMessage("Action")}
        cellRender={renderActions}
        alignment="center"
        hidingPriority={isXSmall || isSmall ? 12 : false}
        width={isXSmall || isSmall ? 100 : 200}
      />
    </DataGrid>
  );
}
